/**
 * The startup screen, shown while the stored token is exchanged for a profile.
 *
 * It replaces the plain "Checking your session…" line. The wording stays, but only
 * screen readers hear it, through role="status". Everything visible fades in after 200ms,
 * so a fast check never flashes the screen, and the eggs stop moving when the breeder asks
 * for reduced motion.
 */
export function StartupScreen() {
  return (
    <div role="status" aria-live="polite" className="relative flex min-h-dvh overflow-hidden bg-surface">
      <span className="sr-only">Checking your session…</span>

      {/* Two soft circles, off the right-top and left-bottom edges. Decoration only. */}
      <span
        aria-hidden
        className="absolute -top-startup-orb-top -right-startup-orb-right size-startup-orb rounded-full bg-primary-fixed"
      />
      <span
        aria-hidden
        className="absolute -bottom-startup-orb-sm-bottom -left-startup-orb-sm-left size-startup-orb-sm rounded-full bg-surface-container"
      />

      <div
        aria-hidden
        className="relative mt-startup-top flex flex-col gap-startup-stack px-gutter-wide animate-startup-in"
      >
        <img src="/logo.svg" alt="" className="size-startup-logo" />

        <div className="flex flex-col gap-startup-words">
          <span className="font-display text-startup text-on-surface">BreeNova</span>
          <span className="max-w-startup-tagline text-body text-on-surface-body text-pretty">
            Breeding records for canaries and goldfinches.
          </span>
        </div>

        <div className="flex h-startup-eggs items-end gap-startup-words">
          <Egg className="bg-accent-mark" />
          <Egg className="bg-action [animation-delay:150ms]" />
          <Egg className="bg-accent-mark [animation-delay:300ms]" />
        </div>
      </div>
    </div>
  );
}

function Egg({ className }: { className: string }) {
  return (
    <span
      className={
        "block h-startup-egg-h w-startup-egg-w rounded-egg-shape " +
        "animate-startup-egg motion-reduce:animate-none " +
        className
      }
    />
  );
}
